export default __webpack_public_path__ + "static/firepit-thumb-83f302d16842834c24f860ce453a8074.jpg";